import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { DateFilterComponent } from './date-filter.component';
import { SafePipeModule } from 'safe-pipe';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [DateFilterComponent],
  imports: [
    CommonModule,
    MatMenuModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatButtonModule,
    MatIconModule,
    ReactiveFormsModule,
    SafePipeModule,
    TranslateModule.forChild(),
  ],
  exports: [DateFilterComponent],
})
export class DateFilterModule {}
